let routes = [{
  path: '/',
  component: (resolve) => require(['./components/index/ShouYe.vue'], resolve),
},
{
  path: '/research',
  component: (resolve) => require(['./components/research/ResearchList.vue'], resolve),
},
{
  path: '/ApplyReg',
  component: (resolve) => require(['./page/applyReg/applyReg'], resolve),
},
{
  path: '/register',
  component: (resolve) => require(['./page/login/reg'], resolve),
},
{
  path: '/UserInfo',
  component: (resolve) => require(['./page/user/index'], resolve),
},
{
  path: '/article/:id',
  component: (resolve) => require(['./components/article/ArticleDetail.vue'], resolve),
},
{
  path: '/works',
  component: (resolve) => require(['./components/works/WorksShow.vue'], resolve),
},
{
  path: '/works/all',
  component: (resolve) => require(['./components/works/AllWorks.vue'], resolve),
},
{
  path: '/Sample',
  component: (resolve) => require(['./components/article/SampleArticle.vue'], resolve),
},
{
  path: '/sample-video',
  component: (resolve) => require(['./components/works/SampleVideo.vue'], resolve),
},
{
  path: '/requirements',
  component: (resolve) => require(['./page/requirements/requirements'], resolve),
},
{
  path: '/training',
  component: (resolve) => require(['./components/peixun/TrainingPage.vue'], resolve),
},
{
  path: '/all-works',
  component: (resolve) => require(['./components/peixun/AllWorks.vue'], resolve),
},
{
  path: '/zhibo-list',
  component: (resolve) => require(['./components/zhibo/ZhiboList.vue'], resolve),
}
];

export default routes;